// extracted by mini-css-extract-plugin
module.exports = {"details":"header_details__2qWh5","header":"header_header__3wy06","logo":"header_logo__13VgX","icon":"header_icon__2BFqW"};